import React from "react";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

const VARIABLE_FIELDS = [
  { key: "gas", label: "Gas Cost", hint: "₹ based on cooking time" },
  { key: "electricity", label: "Electricity", hint: "₹ wattage × cooking time" },
  { key: "water", label: "Water", hint: "₹ per dish" },
  { key: "packaging", label: "Packaging", hint: "₹ per portion" },
  { key: "delivery", label: "Delivery Handling", hint: "₹ per portion" },
];

const FIXED_FIELDS = [
  { key: "labour", label: "Labour Cost", hint: "₹/min × cooking time" },
  { key: "rent", label: "Rent Allocation", hint: "₹ per dish" },
  { key: "kitchen_overhead", label: "Kitchen Overhead", hint: "₹ per dish" },
  { key: "maintenance", label: "Maintenance", hint: "₹ per dish" },
  { key: "misc", label: "Miscellaneous", hint: "₹ per dish" },
];

function NumField({ label, hint, value, onChange, testId }) {
  return (
    <div>
      <Label className="kostra-data-label">{label}</Label>
      <div className="mt-1 relative">
        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-[#4B5563] text-sm">₹</span>
        <Input
          type="number"
          min="0"
          step="0.01"
          value={value ?? 0}
          onChange={(e) => onChange(parseFloat(e.target.value) || 0)}
          className="pl-7 font-mono-num"
          data-testid={testId}
        />
      </div>
      <p className="text-[11px] text-[#4B5563] mt-1">{hint}</p>
    </div>
  );
}

export default function UtilitiesOverheads({ utilities, overheads, onUtilities, onOverheads }) {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <div className="kostra-card p-5 md:p-6" data-testid="utilities-card">
        <h3 className="kostra-section-title text-xl mb-1">Variable Costs</h3>
        <p className="text-xs text-[#4B5563] mb-5">Per-dish utility & handling costs that scale with output.</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {VARIABLE_FIELDS.map((f) => (
            <NumField
              key={f.key}
              label={f.label}
              hint={f.hint}
              value={utilities?.[f.key]}
              onChange={(v) => onUtilities({ ...(utilities || {}), [f.key]: v })}
              testId={`util-${f.key}`}
            />
          ))}
        </div>
      </div>

      <div className="kostra-card p-5 md:p-6" data-testid="overheads-card">
        <h3 className="kostra-section-title text-xl mb-1">Fixed Cost Allocation</h3>
        <p className="text-xs text-[#4B5563] mb-5">Allocated overheads per dish for accurate margin.</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {FIXED_FIELDS.map((f) => (
            <NumField
              key={f.key}
              label={f.label}
              hint={f.hint}
              value={overheads?.[f.key]}
              onChange={(v) => onOverheads({ ...(overheads || {}), [f.key]: v })}
              testId={`oh-${f.key}`}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
